import { render } from "./FormContatto.vue?vue&type=template&id=152275b3&ts=true"
import script from "./FormContatto.vue?vue&type=script&lang=ts"
export * from "./FormContatto.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__